import useSWR from "swr";
import { maxBy } from "lib/actions/util";
import { fetcher } from "lib/actions/fetcher";
import { getAssetFromResponse } from "lib/actions/assets/getAssetFromResponse";
import { endpointsAssets } from "lib/actions/endpoints/endpointsAssets";
import { useMemo } from "react";

export function useAssets(projectId: number) {
  const { data, error, isLoading, mutate } = useSWR(
    projectId && endpointsAssets.projectAssets(projectId),
    (url) =>
      fetcher<unknown[]>(url).then((data) => data.map(getAssetFromResponse)),
  );

  const versions = useMemo(
    () =>
      data?.flatMap((asset) =>
        asset.versions.map((version) => ({ ...version, asset })),
      ),
    [data],
  );
  const latestVersions = useMemo(
    () =>
      data?.map((asset) => ({
        ...maxBy(asset.versions, (version) => version.createdOn),
        asset,
      })),
    [data],
  );
  const hasError = !projectId || !!error;

  function getAssetLatestVersion(id: number) {
    return latestVersions?.find((version) => version.asset.id === id);
  }

  function getAsset(id: number) {
    return data?.find((asset) => asset.id === id);
  }

  return {
    assets: data,
    versions,
    latestVersions,
    isLoading: isLoading && !data,
    hasError,
    getAsset,
    getAssetLatestVersion,
    mutate: async () => {
      await mutate();
    },
  };
}
